import { render, staticRenderFns } from "./casePhotoText.vue?vue&type=template&id=fc4d5d18&lang=pug"
import script from "./casePhotoText.vue?vue&type=script&lang=js"
export * from "./casePhotoText.vue?vue&type=script&lang=js"
import style0 from "./casePhotoText.vue?vue&type=style&index=0&id=fc4d5d18&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports